/**
 * SKAIČIŲ ŽEMĖLAPIS — Static preview catalog for base numbers 1–9.
 *
 * STRICT RULE: These are "Light + Shadow + Crossroads" hooks only. They MUST
 * NOT leak the full dynamic diagnostic Plus/Minus/Center state texts (those
 * live in diagnosticInterpretations.js).
 *
 * STRUCTURE per card:
 *   overview  — the Light + Shadow body (first two sentences).
 *   question  — the Kryžkelės klausimas, rendered as a SEPARATE paragraph.
 *
 * Grammar: 2nd person singular (Tu), neutral. The verb "dalintis" is always
 * conjugated as "daliniesi".
 */

export const NUMBERS_MAP = [
  {
    number: 1,
    title: 'Lyderis ir Pradžia',
    keyword: 'Valia · Iniciatyva',
    overview:
      'Tavyje dega pradininko ugnis, drąsa žengti pirmam ir nubrėžti savo unikalią kryptį. Tačiau patiriant spaudimą, ši jėga gali virsti agresyvia kontrole arba visišku pasidavimu aplinkybėms.',
    question:
      'Ar šiuo metu realizuoji savo kūrėjo potencialą, ar laviruoji tarp lyderystės ir vidinio sąstingio?',
  },
  {
    number: 2,
    title: 'Tarpininkas ir Diplomatas',
    keyword: 'Harmonija · Jautrumas',
    overview:
      'Tavo stiprybė – gilus jautrumas, gebėjimas išklausyti, sukurti harmoniją ir sujungti žmones bendram tikslui. Tačiau bijodamas konflikto, gali ištirpti svetimose nuomonėse ir pamiršti savo paties poreikius.',
    question:
      'Ar šiuo metu tavo empatija veikia kaip jėga, ar kaip nepastebimas prisitaikymas?',
  },
  {
    number: 3,
    title: 'Kūrėjas ir Komunikatorius',
    keyword: 'Kūryba · Saviraiška',
    overview:
      'Tavyje trykšta kūrybos ir saviraiškos šviesa, gebanti paversti idėjas žodžiais, spalvomis ar garsais. Visgi, susidūrus su kritika, tavo optimizmas gali greitai išblėsti ir virsti paviršutiniškumu ar užsisklendimu.',
    question:
      'Ar laisvai daliniesi savo talentais su aplinkiniais, ar esi tarp įkvėpimo ir tuštumos jausmo?',
  },
  {
    number: 4,
    title: 'Statytojas ir Stabilumas',
    keyword: 'Tvarka · Patikimumas',
    overview:
      'Turi neįkainojamą gebėjimą įvesti tvarką, kurti stabilų pagrindą, struktūrą ir logiškai supaprastinti sudėtingus procesus. Vis dėlto, per didelis saugumo siekis kartais sukuria vidinius rėmus, neleidžiančius priimti pokyčių.',
    question:
      'Ar tavo kuriamas stabilumas šiandien suteikia laisvę, ar kelia sąstingį?',
  },
  {
    number: 5,
    title: 'Laisvė ir Nuotykiai',
    keyword: 'Laisvė · Lankstumas',
    overview:
      'Esi judėjimo, laisvės ir nuolatinių ieškojimų siela, lengvai prisitaikanti prie naujų vėjų ir plečianti horizontus. Tačiau neturint aiškaus inkaro, šis smalsumas gali virsti chaotišku blaškymusi ar bėgimu nuo įsipareigojimų.',
    question:
      'Ar dabartiniame gyvenimo etape tavo laisvė veda į gilesnę patirtį, ar į nerimastingą blaškymąsi?',
  },
  {
    number: 6,
    title: 'Globėjas ir Harmonija',
    keyword: 'Rūpestis · Šiluma',
    overview:
      'Tavo širdyje gyvena rūpestis ir gebėjimas kurti jaukumą bei šilumą aplink save. Tačiau bijodamas prarasti artimuosius, gali pernelyg globoti, kontroliuoti ar aukotis pamiršdamas save.',
    question:
      'Ar rūpiniesi kitais iš vidinės pilnatvės, ar dėl jų meilės išsižadi savęs?',
  },
  {
    number: 7,
    title: 'Ieškotojas ir Išminčius',
    keyword: 'Išmintis · Intuicija',
    overview:
      'Tavo protas ieško gilesnės prasmės ir mato tai, kas slypi už kasdienybės paviršiaus. Tačiau apimtas įtampos, gali užsisklęsti vienatvėje, paskęsti abejonėse ir prarasti ryšį su aplinkiniais.',
    question:
      'Ar daliniesi savo įžvalgomis ir išmintimi, ar laviruoji tarp gilaus žinojimo ir izoliuojančio skepticizmo?',
  },
  {
    number: 8,
    title: 'Valdovas ir Galybė',
    keyword: 'Ambicija · Strategija',
    overview:
      'Tavyje užkoduotas mąstytojo mąstelis, gebėjimas valdyti materialius resursus, realizuoti ambicingas vizijas ir prisiimti atsakomybę už didelius projektus. Visgi, patiriant stresą, ši ambicija gali peraugti į emocinį šaltumą arba stiprų vidinį spaudimą sau ir kitiems.',
    question:
      'Ar tavo vidinė galia dabar kuria klestėjimą, ar virsta sunkiu krūviu ir baime pralaimėti?',
  },
  {
    number: 9,
    title: 'Humanistas ir Užbaigimas',
    keyword: 'Užuojauta · Tarnystė',
    overview:
      'Tavyje gyvena plati, besąlygiška meilė pasauliui ir gilus dvasinis ryšys, leidžiantis nuoširdžiai priimti bei užjausti kiekvieną. Tačiau laiku neapsaugojus savo asmeninių ribų, šis dosnumas gali virsti svetimo skausmo nešimu ir visišku vidiniu išsekimu.',
    question:
      'Ar daliniesi savo šviesa iš vidinės pilnatvės, ar laviruoji tarp besąlyginės meilės ir emocinio išsekimo?',
  },
];
